import Card from './card';
import CardTitle from './cardTitle';
export { CardTitle };

export default Card;
